import React from 'react';

export const PlayIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24">
    <path d="M21.37,10.71A1.53,1.53,0,0,1,22,12a1.64,1.64,0,0,1-.63,1.32A66.47,66.47,0,0,1,4.93,22.86a2,2,0,0,1-.71.14,1.83,1.83,0,0,1-.94-0.25,1.59,1.59,0,0,1-.85-1.32q0-.22-0.13-1.42T2.1,16.48Q2,14.15,2,12T2.1,7.53Q2.2,5.21,2.3,4T2.43,2.59a1.66,1.66,0,0,1,.85-1.35A1.83,1.83,0,0,1,4.22,1a2,2,0,0,1,.71.14q2.56,1,5.18,2.36T14.59,6q1.84,1.14,3.49,2.28T20.44,10Q21.15,10.49,21.37,10.71Z" />
  </svg>
);
